module.exports = __webpack_public_path__ + "img/jcfw.5edfedab.png";